// RiverHack specific colors
export const riverhackColors = {
  deepPurple: '#32286f',  // Primary color
  sandBeige: '#f6debd',   // Background accent
  vibrantOrange: '#ea542f', // Call to action
  burgundy: '#713959',    // Secondary color
  terracotta: '#c75e52'   // Accent color
};

export const riverhackThemeExtension = {
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: riverhackColors.sandBeige,
          color: riverhackColors.deepPurple,
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          backgroundColor: riverhackColors.vibrantOrange,
          color: '#fff',
          '&:hover': {
            backgroundColor: riverhackColors.terracotta,
          }
        }
      }
    }
  }
}; 